function DsUsersCtrl($scope, $timeout, $state, $controller, GeneralUtilsService){
    $controller('ConfigController', {$scope: $scope, $timeout: $timeout});

    $scope.datamodified = false;
    $scope.hostsdatamodified = false;

    $scope.$root.hasChanges = function(){
        var accesslogin = $scope.accesslogin;
        if(!accesslogin) return false;
        if(accesslogin.id < 0) return true; //new accesslogin
        if ($scope.hostsConfig){
            if(!angular.equals($scope.hostsConfig.items,$scope.hostsConfig.origItems)) return true;
        }
        if(!angular.equals($scope.accesslogin,$scope.orig)) return true;
        return false;
    };

    $scope.resendInvitations = function(selectedItems,type) {
        var items = [];
        var nameList = [];
        selectedItems.forEach(function(item){
            items.push(item.id);
            nameList.push(item.name);
        });
        var data = {"items":items,"type":type};
        var len = selectedItems.length;
        if(len == 0) {
            $scope.$root.alert("Please select users");
            return;
        }


        var itemsMessage = (len == 1? "invitation to one user: ": len + " invitations to selected users: ") + nameList.join(', ');
        $scope.$root.confirm("Are you sure you want to resend " +  itemsMessage + "?", function(){
            store.action({
                path: 'resendMail',
                data : data,
                dataObj:"json",
                success: function(data) {
                    $scope.$root.handleServerResponse(data,"", "Invitations were sent to the selected users",null,true);
                }
            });
        });
    };

    $scope.resetPassword = function(selectedItems,type){
        var items = [];
        var nameList = [];
        selectedItems.forEach(function(item){
            items.push(item.id);
            nameList.push(item.name);
        });
        var data = {"items":items,"type":type};
        var len = selectedItems.length;
        if(len == 0) {
            $scope.$root.alert("Please select users");
            return;
        }
        var itemsMessage = (len == 1?"to one user: ":"to " + len + " selected users: ") + nameList.join(', ');
        $scope.$root.confirm("Are you sure you want to reset password " +  itemsMessage + "?", function(){

            store.action({
                path: 'resetPasswords',
                data : data,
                dataObj:"json",
                success: function(data) {
                    $scope.$root.handleServerResponse(data,"", "Passwords were reset and invitations were send to the users",null,true);
                }
            });
        });
    };


    $scope.unLock = function(){
        $scope.$root.confirm("Are you sure you want to unlock user " + $scope.accesslogin.firstName + "  " + $scope.accesslogin.lastName + " ?", function(){
            store.save({
                path: 'unlockUser',
                queryParams : {"accessloginId":$scope.accesslogin.id},
                success: function(data) {
                    $scope.$root.handleServerResponse(data,"", 'User is unlocked');
                    if(data.status !== "ERROR"){
                        $scope.reloadUser(data);
                    }
                }
            });
        });
    };


    $scope.tableConfig = {
        noAutoCheckboxSelect: true,
        clientSideSearch: true,
        statusNames:{"DISABLED":"Disabled","ACTIVE":"Configured","LOCKED":"Locked","NEW":"New","PENDING_USER_CONFIGURATION":"Invitation Sent"},
        loginNameById:{},
        dataURL : function(){
            return "/getAllDsUsers?accountId=" + ($state.params.accountId? $state.params.accountId : "");
        },
//        processData : function(items){
//            allowNewUsers();
//        },
        titleSearch: 'Users',
        accountId : $state.params.accountId,
        batchAddURL : function(){
            return "/batchUpload?type=AccessLogin&parent=logins&accountId=" + $state.params.accountId;
        },
        height: $scope.getContentHeight(),
        sortButton: true,
        pageSize: -1,
        afterUpdate: function(){
            if($scope.$root){
                $scope.$root.updateScroll('.pane.left .nano');
            }
        },
        searchId: $state.params.id, // in case there is a search value in the URL params, use it to search
        fields : [{"label":"Name","path":"name","template":"<span>{{item.prefix}}{{item.name}}</span>"},
            {"label":"E-mail","path":"email"},
            {"label":"Status","path":"status","template":"<span><span ng-show='item.status == \"LOCKED\"' class='glyphicon glyphicon-lock error'></span> {{tableConfig.statusNames[item.status]}}</span>"},
            {"label":"Origin","path":"importType","template":"<span>{{item.importType == 'LDAP'?'LDAP defined':'User defined'}}</span>"},
            {"label":"Creation Date","path":"creationDate"},
            {"label":"Last Modified","path":"lastModified"}/*,
             {"label": "", "template": '<img src="/public/images/connectivity.png" style="cursor:' +
             ' pointer;" data-toggle="modal" data-target="#myModal" data-type="login" data-id="{{item.id}}"></img>'}*/
        ],
        type : "DirectoryServiceUser",
        addAction : function(type) {
            this.addNew(type);
        },
        addNew : function(){
          $scope.newLogin= {id:GeneralUtilsService.getRandomId(),"name":"","status":"NEW"};
          $scope.$root.openPopup('addLoginDlg');
        },
        actions: ["remove"],
        specialActions:[
            {"func":function(selectedItems) {
                $scope.disable(selectedItems,"AccessLogin");
            },"icon":"disable",tooltip:"Disable Users"},
            {"func":function(selectedItems) {
                $scope.disable(selectedItems,"AccessLogin",true);
            },"icon":"enable",tooltip:"Enable Users"},
            {"func":function(selectedItems) {
                $scope.resendInvitations(selectedItems,"AccessLogin");
            },"icon":"retweet",tooltip:"Resend invitations"},
            {"func":function(selectedItems) {
                $scope.resetPassword(selectedItems,"AccessLogin");
            },"icon":"password",tooltip:"Reset Passwords"}
        ],
        onSelect : function(index) {
            store.fetch({
                path: '/show?type=directoryserviceuser&directoryserviceuserId=' + $scope.tableConfig.items[index].id,
                success: function (data) {
                    if(!$scope.loaded){
                        return;
                    }

                    $timeout(function() {
                        $scope.$root.clearErrors();
                        $scope.accesslogin = data;
                        $scope.orig = angular.copy($scope.accesslogin);
                        $scope.hostsdatamodified = new Date().getTime();

                        if(isSystemLogin){
                            $scope.generalpropertiesdatamodified = new Date().getTime();
                        }

                        $scope.updateRightScroll();
                    }, 0);

                }
            });
        }
    };


    function setStatus(items, set, setTo){
        if(items && items.length > 0){
            items.forEach(function(item){
                if(set){
                    item.isActive = setTo;
                }
                else {
                    item.isActive = (item.status == 'ACTIVE');
                }
            });
        }
    }

    var updateGeneralProperties = function() {
//        if ($scope.generalPropertiesConfig && $scope.generalPropertiesConfig.items) {
//            $scope.accesslogin.generalProperties = angular.copy($scope.generalPropertiesConfig.items);
//        }
//        // had to add AllowIndirectRemovals annotation (cascade problem) - but when this annotation is added delete of subItems are done according to comparing list
//        // which mean deleting subItems from other pages, to avoid unwanted removals added a check if item is part of delete map - also if there are no deleted items
//        if (!$scope.accesslogin.itemsToDelete){
//            $scope.accesslogin.itemsToDelete = {};
//        }
//        if (!$scope.accesslogin.itemsToDelete.generalProperties){
//            $scope.accesslogin.itemsToDelete.generalProperties = [];
//        }
    };


    $scope.edit = function(){
        updateGeneralProperties();

        $scope.accesslogin.newSaveMethod = true;
        $scope.accesslogin.machines = $scope.hostsConfig.items.map(function(mac) {return mac.name});
        store.save({
            path: "/edit",
            data: $scope.accesslogin,
            dataObj: 'json',
            queryParams: {'directoryserviceuserId':$scope.accesslogin.id,'save':true, 'accountId': $state.params.accountId},
            success: function(data) {
                $scope.$root.handleServerResponse(data,"directoryserviceuser", 'User saved successfully');
                if(data.status !== "ERROR"){
                    $scope.reloadUser(data.model);
                }
            }
        });
    };


    $scope.reloadUser = function(data){
        $scope.accesslogin = data;
        $scope.orig = angular.copy($scope.accesslogin);
        if(isSystemLogin){
            $scope.generalpropertiesdatamodified = new Date().getTime();
        }
        $scope.hostsdatamodified = new Date().getTime();
        $scope.tableConfig.selectedId = data.id;
    };


    $scope.addLogin = function(){
        $scope.newLogin.name = $scope.newLogin.loginName;
        var params = {'accountId': $state.params.accountId,'type':'DirectoryServiceUser','save':true};
        store.save({
            path: "/add",
            data: $scope.newLogin,
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                $scope.$root.handleServerResponse(data,"newLogin", "User added successfully");
                if(data.status !== "ERROR"){
                    $scope.tableConfig.selectedId = data.model.id;
                    $scope.datamodified = new Date().getTime();
                    $scope.$root.closePopup('addLoginDlg');
                }
            }
        });
    };

    $scope.hostsConfig = {

            dataURL : function(){
                return null;
            },
            parseData : function() {
                var machines = [];
                $scope.accesslogin.machines.forEach(function(machine){
                    machines.push({name:machine});
                });

                $scope.hostsConfig.origItems = angular.copy(machines);
                return machines;
            },
            showTable: false,
            fields : [
                {"label":"Name","path":"item","template":"<span><input type='text' class='form-control' ng-model='item.name'/></span>"}
            ],
            actions: [],
            selectedItems:[],
            pageSize:10,
            defer:true,
            specialActions : [
                {'icon':'add','tooltip':'Add','func' :
                    function(selectedItems,config) {
                        $scope.hostsConfig.items.push({id:GeneralUtilsService.getRandomId(),"name":"","subnetType":'Department'});
                        $scope.updateRightScroll();
                    }
                },
                {'icon':'delete','tooltip':'Delete','func' :
                    function(selectedItems,config) {
                        var deletedHosts = [];
                        selectedItems.forEach(function(item) {
                            for(var i = 0 ; i < $scope.hostsConfig.items.length ; i++){
                                var subnet = $scope.hostsConfig.items[i];
                                if(subnet.id === item.id){
                                    $scope.hostsConfig.items.splice(i,1);
                                    break;
                                }
                            }
                            if (item.id > 0) {
                                deletedHosts.push(item);
                            }
                        });
                        if (deletedHosts.length > 0) {
                            $scope.site.itemsToDelete.hosts = ($scope.site.itemsToDelete.hosts && $scope.site.itemsToDelete.hosts.length > 0) ?
                                                                    deletedHosts.concat($scope.site.itemsToDelete.hosts) :
                                                                    deletedHosts;
                        }
                        $scope.updateRightScroll();
                    }
                }
            ],
            noSearch:true
        };

}

